import {
  HubConnectionBuilder,
  HubConnection,
  HubConnectionState,
} from "@microsoft/signalr";

export class Signal {
  public get connected(): boolean {
    return this.connection.state === HubConnectionState.Connected;
  }

  private connection: HubConnection;
  private token?: string;

  constructor(
    url: string,
    private _fn?: () => void,
  ) {
    this.connection = new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: () => this.token!,
      })
      .withAutomaticReconnect()
      .build();

    this.connection.onreconnected(() => {
      this._fn?.();
    });
    this.connection.onreconnecting(() => {
      this._fn?.();
    });
    this.connection.onclose(() => {
      this._fn?.();
    });
  }

  public start(token: string): void {
    console.log("Hub start");
    this.token = token;
    try {
      this.connection
        .start()
        .then(() => {
          console.log("Hub connected");
          this._fn?.();
        })
        .catch((err) => {
          console.error("Hub connection error: ", err);
          this._fn?.();
        });
    } catch {}
  }

  public close(): void {
    try {
      this.connection
        .stop()
        .then(() => {
          console.log("Hub closed");
        })
        .catch((err) => {
          console.error("Hub closing error: ", err);
        });
    } catch {}
  }

  public on(name: string, fn: (...args: any[]) => void) {
    this.connection.on(name, fn);
  }

  public off(name: string, fn: (...args: any[]) => void) {
    this.connection.off(name, fn);
  }

  public send(name: string, ...args: any[]) {
    this.connection.send(name, args);
  }
}
